var _excluded = ["children", "className", "label", "value"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import classnames from 'classnames';
import React from 'react';
import FormLabelGroup from '../Form/FormLabelGroup';
import Input from '../Input/Input'; // For some reason I was getting import errors when importing FormLabelGroupProps without `type`
// TODO: Revert to extends FormLabelGroupProps when we support TS 4.5+

/**
 * Datapairs are an extension to FormLabelGroup for displaying labeled data. Each element is comprised
 * of two parts: the key (label) and a value. The key is an identifier for some form of data and
 * the value can be text or links.
 */
var Datapair = _ref => {
  var children = _ref.children,
      className = _ref.className,
      label = _ref.label,
      value = _ref.value,
      attributes = _objectWithoutProperties(_ref, _excluded);

  var classNames = classnames('js-datapair', 'text-break', className);
  return /*#__PURE__*/React.createElement(FormLabelGroup, _extends({
    inline: true,
    label: label,
    rowClassName: classNames
  }, attributes), children || /*#__PURE__*/React.createElement(Input, {
    plaintext: true,
    tag: "div"
  }, value));
};

Datapair.displayName = "Datapair";
Datapair.displayName = 'Datapair';
export default Datapair;